import { render, staticRenderFns } from "./FactoryInvoiceViewPage.vue?vue&type=template&id=13be0b8b&scoped=true&"
import script from "./FactoryInvoiceViewPage.vue?vue&type=script&lang=ts&"
export * from "./FactoryInvoiceViewPage.vue?vue&type=script&lang=ts&"
import style0 from "./FactoryInvoiceViewPage.vue?vue&type=style&index=0&id=13be0b8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13be0b8b",
  null
  
)

export default component.exports